module.exports = __webpack_public_path__ + "img/2.6_Russian_road_sign.9fd33400.svg";